// extracted by mini-css-extract-plugin
module.exports = {"markdown":"Markdown_markdown__JWOf5","table":"Markdown_table__RvGJe","th":"Markdown_th__I3aks","td":"Markdown_td__vHnvE","markdownImage":"Markdown_markdownImage__Rg_At"};